import { z } from 'zod';

export const mailDirectionSchema = z.enum(['outbound', 'inbound']);
export type MailDirection = z.infer<typeof mailDirectionSchema>;

export const mailStatusSchema = z.enum([
  'queued',
  'sent',
  'delivered',
  'bounced',
  'complained',
  'opened',
  'clicked',
  'failed',
  'received',
]);
export type MailStatusEnum = z.infer<typeof mailStatusSchema>;

export const listMailLogsQuerySchema = z.object({
  direction: mailDirectionSchema.optional(),
  status: mailStatusSchema.optional(),
  q: z.string().max(255).optional(),
  page: z.coerce.number().int().positive().default(1),
  perPage: z.coerce.number().int().min(1).max(100).default(25),
});
export type ListMailLogsQuery = z.infer<typeof listMailLogsQuerySchema>;

export const updateMailCredentialsSchema = z
  .object({
    // Resend API key: re_... (admin paneli boş bırakırsa undefined olur, set
    // edilmez. Boş string verirse explicit silinmiş kabul edilir).
    apiKey: z
      .string()
      .max(200)
      .regex(/^(|re_[A-Za-z0-9_]+)$/, 'Geçersiz Resend API key formatı (re_...)')
      .optional(),
    // Webhook secret: whsec_... (Svix formatı)
    webhookSecret: z
      .string()
      .max(200)
      .regex(/^(|whsec_[A-Za-z0-9+/=_-]+)$/, 'Geçersiz webhook secret formatı (whsec_...)')
      .optional(),
    fromAddress: z
      .string()
      .max(200)
      .refine(
        (v) => v === '' || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v),
        'Geçerli bir e-posta adresi girin',
      )
      .optional(),
    fromName: z.string().max(120).optional(),
  })
  .refine(
    (d) =>
      d.apiKey !== undefined ||
      d.webhookSecret !== undefined ||
      d.fromAddress !== undefined ||
      d.fromName !== undefined,
    { message: 'En az bir alan güncellenmeli' },
  );
export type UpdateMailCredentialsInput = z.infer<typeof updateMailCredentialsSchema>;
